import { useAtom } from 'jotai';
import Image from 'next/legacy/image';

import facebook from '/public/images/graduate/facebook.png';
import kakao from '/public/images/graduate/kakao.png';
import twitter from '/public/images/graduate/twitter.png';
import closeIcon from '/public/images/icons/close-icon.png';
import OutsideClickedWrapper from '@/components/common/OutsideClickedWrapper';
import {
  copyText,
  shareFacebook,
  shareKakao,
  shareTwitter,
} from '@/lib/utils/businessLogics/graduate';
import { graduateShareModalAtom } from '@/store/v2/graduate';

import * as S from './style';

export default function ShareModal({ graduateName }: { graduateName: string }) {
  const [modal, setModal] = useAtom(graduateShareModalAtom);
  const currentUrl = window.document.location.href;
  return (
    modal && (
      <S.ModalBackground>
        <OutsideClickedWrapper setState={setModal}>
          <S.Modal>
            <S.ModalHeader>
              <S.ModalTitleText>공유하기</S.ModalTitleText>
              <S.ModalClose>
                <Image
                  src={closeIcon}
                  width={16}
                  height={16}
                  alt='close-icon'
                  onClick={() => setModal(false)}
                />
              </S.ModalClose>
            </S.ModalHeader>
            <S.ModalBody>
              <S.Kakao>
                <Image
                  src={kakao}
                  width={64}
                  height={64}
                  alt='kakaotalk'
                  onClick={() => shareKakao(currentUrl, graduateName)}
                />
                <span>카카오톡</span>
              </S.Kakao>
              <S.Facebook>
                <Image
                  src={facebook}
                  width={64}
                  height={64}
                  alt='kakaotalk'
                  onClick={() => shareFacebook(currentUrl)}
                />
                <span>페이스북</span>
              </S.Facebook>
              <S.Twitter>
                <Image
                  src={twitter}
                  width={64}
                  height={64}
                  alt='kakaotalk'
                  onClick={() => shareTwitter(currentUrl)}
                />
                <span>트위터</span>
              </S.Twitter>
            </S.ModalBody>
            <S.Link>
              <S.Url>{currentUrl}</S.Url>
              <S.ShareButton onClick={() => copyText(currentUrl)}>
                복사
              </S.ShareButton>
            </S.Link>
          </S.Modal>
        </OutsideClickedWrapper>
      </S.ModalBackground>
    )
  );
}
